import { useEffect } from 'react';

/**
 * Lightweight SEO hook — updates <title> and meta description on route changes.
 * No external dependency. Good enough for static-content SEO on a small site.
 */
export default function useSEO({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
}
